import vex from 'vex-js';
import vexDialog from 'vex-dialog';


vex.registerPlugin(vexDialog);
vex.defaultOptions.className = 'vex-theme-mediastorm';
const modal = vex;

export default modal;
